export const API_URL = "https://guide.digitain.com/wp_post.php"

export const AUTHORIZATION = "Bearer eoqqcofwqrB2qQeAREK1B8bb4UlGvAegj9FH9jjefJvSLPrpcWseh9ptRgf2DLSei0q5S7YkFPoDGeLfGiAS3UP9g9A4hehfLwry"